import { useTextos } from "../context/useTextos";
import StatusBadge from "./StatusBadge";
import AvariasPanel from "./AvariasPanel";
import { normalizeAvarias } from "../lib/avariaModel";
import { getCategorias, FOTOS_GERAIS_ITEM_ID } from "../lib/checklistTemplate";
import { downloadChecklistHtml, printChecklistAsPdf } from "../lib/exportChecklist";
import { useWorkshop } from "../context/useWorkshop";
import { useSettings } from "../context/useSettings";

export default function ChecklistDetail({ checklist, onEdit, onBack }) {
  const { t } = useTextos();
  const categorias = getCategorias();
  const { workshopName } = useWorkshop();
  const { settings } = useSettings();
  const exportOptions = { workshopName, logoUrl: settings.logoUrl };
  const avarias = normalizeAvarias(checklist.avarias);
  const fotosGeraisItem = checklist.itens.find((i) => i.id === FOTOS_GERAIS_ITEM_ID);

  return (
    <div className="checklist-detail">
      <header className="checklist-detail__header">
        <button className="btn btn--ghost" onClick={onBack}>
          {t("checklist.detail_voltar")}
        </button>
        <StatusBadge status={checklist.status} kind="checklist" />
        <div className="checklist-detail__actions">
          <button
            className="btn btn--secondary btn--small"
            onClick={() => downloadChecklistHtml(checklist, exportOptions)}
          >
            {t("checklist.detail_exportar_html")}
          </button>
          <button
            className="btn btn--secondary btn--small"
            onClick={() => printChecklistAsPdf(checklist, exportOptions)}
          >
            {t("checklist.detail_exportar_pdf")}
          </button>
          <button className="btn btn--secondary" onClick={onEdit}>
            {t("common.editar")}
          </button>
        </div>
      </header>

      <section className="form-section">
        <h3>{t("checklist.detail_cliente_veiculo")}</h3>
        <p>
          <strong>{checklist.cliente.nome || "—"}</strong> · {checklist.cliente.telefone || "—"}
        </p>
        <p>
          {checklist.veiculo.marca} {checklist.veiculo.modelo} ({checklist.veiculo.ano}) ·
          {t("checklist.detail_placa_prefix")} {checklist.veiculo.placa || "—"} · {checklist.veiculo.km || "—"} km
        </p>
        <p>{t("checklist.detail_mecanico_responsavel")} {checklist.mecanicoResponsavel || "—"}</p>
      </section>

      {categorias.map((categoria) => (
        <section className="form-section" key={categoria}>
          <h3>{categoria}</h3>
          {checklist.itens
            .filter((i) => i.categoria === categoria)
            .map((item) => (
              <div className="item-row item-row--readonly" key={item.id}>
                <div className="item-row__top">
                  <span className="item-row__nome">{item.nome}</span>
                  <StatusBadge status={item.status} kind="item" />
                </div>
                {item.observacao && <p className="item-row__obs-text">{item.observacao}</p>}
                {item.fotos.length > 0 && (
                  <div className="photo-upload__thumbs">
                    {item.fotos.map((foto, i) => (
                      <img key={i} src={foto} alt="evidência" className="thumb-readonly" />
                    ))}
                  </div>
                )}
              </div>
            ))}
        </section>
      ))}

      {fotosGeraisItem && fotosGeraisItem.fotos.length > 0 && (
        <section className="form-section">
          <h3>{t("checklist.detail_fotos_gerais")}</h3>
          <div className="photo-upload__thumbs">
            {fotosGeraisItem.fotos.map((foto, i) => (
              <img key={i} src={foto} alt="evidência geral" className="thumb-readonly" />
            ))}
          </div>
        </section>
      )}

      <AvariasPanel avarias={avarias} readOnly modeloId={checklist.veiculo.modelo3dId || undefined} />

      {checklist.observacoesGerais && (
        <section className="form-section">
          <h3>{t("checklist.form_observacoes_gerais")}</h3>
          <p>{checklist.observacoesGerais}</p>
        </section>
      )}

      <section className="form-section form-section--signatures">
        <h3>{t("checklist.detail_assinaturas")}</h3>
        <div className="signatures-grid">
          <div>
            <p className="hint">{t("checklist.detail_mecanico")}</p>
            {checklist.assinaturaMecanico ? (
              <img src={checklist.assinaturaMecanico} alt="assinatura mecânico" />
            ) : (
              <p className="empty-state">{t("checklist.detail_nao_assinado")}</p>
            )}
          </div>
          <div>
            <p className="hint">{t("checklist.detail_cliente")}</p>
            {checklist.assinaturaCliente ? (
              <img src={checklist.assinaturaCliente} alt="assinatura cliente" />
            ) : (
              <p className="empty-state">{t("checklist.detail_nao_assinado")}</p>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
